import { render, staticRenderFns } from "./GlobalPromoRules.vue?vue&type=template&id=5528e9a6"
import script from "./GlobalPromoRules.vue?vue&type=script&lang=js"
export * from "./GlobalPromoRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports